module.exports = __webpack_public_path__ + "img/flyers.a7f67628.svg";